import { render, staticRenderFns } from "./TotpSetup.vue?vue&type=template&id=0e8bdc1d&scoped=true"
import script from "./TotpSetup.vue?vue&type=script&lang=js"
export * from "./TotpSetup.vue?vue&type=script&lang=js"
import style0 from "./TotpSetup.vue?vue&type=style&index=0&id=0e8bdc1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8bdc1d",
  null
  
)

export default component.exports